import React, { useState } from 'react';
import { animated, Spring } from '@react-spring/web';
import { clsx, createUseStyles } from '@pushpay/styles';
import { useMeasure } from '@pushpay/utils';
const useStyles = createUseStyles({
  root: {
    overflow: 'hidden'
  },
  wrapper: {},
  wrapperVertical: {},
  wrapperHorizontal: {
    width: 'fit-content'
  }
});

const ExpandPanel = ({
  expandStatus,
  overflowVisible = false,
  expandDirection = 'vertical',
  collapsedHeightPx = 0,
  collapsedWidthPx = 0,
  classes: classesProp,
  className: classNameProp,
  children,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  const [nodeRef, {
    height: measuredHeight,
    width: measuredWidth
  }] = useMeasure();
  const [overflowStyle, setOverflowStyle] = useState('hidden');
  const isCollapsed = expandStatus === 'collapsed';
  const onStartRestProps = overflowVisible && {
    onStart: () => isCollapsed && setOverflowStyle('hidden'),
    onRest: () => !isCollapsed && setOverflowStyle('visible')
  };
  const content = /*#__PURE__*/React.createElement("div", {
    ref: nodeRef,
    className: clsx(classes.wrapper, {
      [classes.wrapperHorizontal]: expandDirection === 'horizontal',
      [classes.wrapperVertical]: expandDirection === 'vertical'
    })
  }, children);

  if (expandDirection === 'horizontal') {
    return /*#__PURE__*/React.createElement(Spring, Object.assign({
      to: {
        overflow: overflowStyle,
        width: isCollapsed ? collapsedWidthPx : measuredWidth
      }
    }, onStartRestProps), ({
      overflow,
      width
    }) => /*#__PURE__*/React.createElement(animated.div, Object.assign({
      className: className,
      style: {
        width: expandStatus === 'preexpanded' ? 'fit-content' : width,
        overflow: expandStatus === 'preexpanded' ? 'visible' : overflow
      }
    }, rest), content));
  }

  return /*#__PURE__*/React.createElement(Spring, Object.assign({
    to: {
      overflow: overflowStyle,
      height: isCollapsed ? collapsedHeightPx : measuredHeight
    }
  }, onStartRestProps), ({
    overflow,
    height
  }) => /*#__PURE__*/React.createElement(animated.div, Object.assign({
    className: className,
    style: {
      height: expandStatus === 'preexpanded' ? 'auto' : height,
      overflow: expandStatus === 'preexpanded' ? 'visible' : overflow
    }
  }, rest), content));
};

export default ExpandPanel;